import { deleteData } from "../deleteData";
import { IAxiosBlankReturn } from "../interface";

/**
 * Delete a TLF item by id.
 *
 * @param backEndUrl - Base backend URL
 * @param id - TLF id to delete
 * @returns Axios-like result object
 */
export const deleteTlf = async (backEndUrl: string, id: string): Promise<IAxiosBlankReturn> => {
  return await deleteData(`${backEndUrl}TlfItems/${id}`);
};
